import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
//
import DashboardSale from './pages/Dashboard/Sale';
import DashboardEntry from './pages/Dashboard/Entry';
import EventList from './pages/Event/List';
import EventCreate from './pages/Event/Create';
import EventEdit from './pages/Event/Edit';
import TicketList from './pages/Ticket/List';
import VoucherList from './pages/Voucher/List';
import QRCodeScanner from './pages/QRCode/Scanner';
import OrderList from './pages/Order/List';
import OrderShow from './pages/Order/Show';
import EntryList from './pages/Entry/List';
import EntryShow from './pages/Entry/Show';
import Profile from './pages/Profile';
import SettingsGeneral from './pages/Settings/General';
import SettingsTheme from './pages/Settings/Theme';
import NotFound from './pages/Page404';

// ----------------------------------------------------------------------

const onNewScanResult = (decodedText, decodedResult) => {
  // handle decoded results here
  console.log('decodedText', decodedText);
  console.log('decodedResult', decodedResult);
};

export default function Router() {
  return useRoutes([
    {
      path: '/dashboard/sales',
      element: <DashboardLayout />,
      children: [{ element: <DashboardSale />, path: '' }]
    },
    {
      path: '/dashboard/entries',
      element: <DashboardLayout />,
      children: [{ element: <DashboardEntry />, path: '' }]
    },
    {
      path: '/event/list',
      element: <DashboardLayout />,
      children: [{ element: <EventList />, path: '' }]
    },
    {
      path: '/event/create',
      element: <DashboardLayout />,
      children: [{ element: <EventCreate />, path: '' }]
    },
    {
      path: '/event/edit',
      element: <DashboardLayout />,
      children: [{ element: <EventEdit />, path: '' }]
    },
    {
      path: '/ticket/list',
      element: <DashboardLayout />,
      children: [{ element: <TicketList />, path: '' }]
    },
    {
      path: '/voucher/list',
      element: <DashboardLayout />,
      children: [{ element: <VoucherList />, path: '' }]
    },
    {
      path: '/qrcode/scanner',
      element: <DashboardLayout />,
      children: [
        {
          element: (
            <QRCodeScanner
              fps={10}
              qrbox={250}
              disableFlip={false}
              qrCodeSuccessCallback={onNewScanResult}
            />
          ),
          path: ''
        }
      ]
    },
    {
      path: '/order/list',
      element: <DashboardLayout />,
      children: [{ element: <OrderList />, path: '' }]
    },
    {
      path: '/order/:orderId',
      element: <DashboardLayout />,
      children: [{ element: <OrderShow />, path: '' }]
    },
    {
      path: '/entry/list',
      element: <DashboardLayout />,
      children: [{ element: <EntryList />, path: '' }]
    },
    {
      path: '/entry/:entryId',
      element: <DashboardLayout />,
      children: [{ element: <EntryShow />, path: '' }]
    },
    {
      path: '/profile',
      element: <DashboardLayout />,
      children: [{ element: <Profile />, path: '' }]
    },
    {
      path: '/settings/general',
      element: <DashboardLayout />,
      children: [{ element: <SettingsGeneral />, path: '' }]
    },
    {
      path: '/settings/theme',
      element: <DashboardLayout />,
      children: [{ element: <SettingsTheme />, path: '' }]
    },
    {
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        { path: '404', element: <NotFound /> },
        { path: '/', element: <Navigate to="/event/list" /> },
        { path: '*', element: <Navigate to="/404" /> }
      ]
    },
    { path: '*', element: <Navigate to="/404" replace /> }
  ]);
}
